import Phaser from 'phaser'
import EditorHandle from '../actors/editorHandle'

export default class MovingObjectEditor {
  constructor (scene, movingObjectComponent, editable) {
    this.scene = scene

    this.editable = editable
    this.movingObjectComponent = movingObjectComponent

    this.handlers = []
    // this.addHandler(this.editable.image.x, this.editable.image.y, (x, y) => { this.setPos(x, y) })
    // this.addHandler(this.movingObjectComponent.p0.x, this.movingObjectComponent.p0.y, (x, y) => { this.setP0(x, y) })
    this.addHandler(this.movingObjectComponent.p1.x, this.movingObjectComponent.p1.y, (x, y) => { this.setP1(x, y) })
  }

  showHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].show()
    }

    this.refreshHandlerPositions()
    this.movingObjectComponent.startEdit()
  }

  hideHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].hide()
    }

    this.movingObjectComponent.unpause()
  }

  addHandler (x, y, callback) {
    var handler = new EditorHandle(this.scene, x, y, this, callback, 'editor_pos')
    this.scene.add.existing(handler)
    this.handlers.push(handler)
  }

  refreshHandlerPositions () {
    // this.handlers[0].image.x = this.editable.image.x
    // this.handlers[0].image.y = this.editable.image.y
    // this.handlers[1].image.x = this.movingObjectComponent.p0.x
    // this.handlers[1].image.y = this.movingObjectComponent.p0.y
    this.handlers[0].image.x = this.movingObjectComponent.p1.x
    this.handlers[0].image.y = this.movingObjectComponent.p1.y
  }

  setP0 (x, y) {
    this.movingObjectComponent.refreshPath(new Phaser.Math.Vector2(x, y), this.movingObjectComponent.p1)
    this.movingObjectComponent.actor.onEdit()
  }

  setP1 (x, y) {
    this.movingObjectComponent.refreshPath(this.movingObjectComponent.p0, new Phaser.Math.Vector2(x, y))
    this.movingObjectComponent.actor.onEdit()
  }

  setPos (x, y) {
    var p0 = this.movingObjectComponent.p0
    var p1 = this.movingObjectComponent.p1

    var xDiff = x - this.editable.image.x
    var yDiff = y - this.editable.image.y

    this.editable.image.x += xDiff
    this.editable.image.y += yDiff
    p0.x += xDiff
    p1.x += xDiff
    p0.y += yDiff
    p1.y += yDiff

    this.movingObjectComponent.refreshPath(p0, p1)
    this.movingObjectComponent.actor.onEdit()
  }

  delete () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].delete()
    }
  }
}
